import Login from 'pages/Login';
import { lazy } from 'react';
const Survey = lazy(() => import('pages/Executor/Survey'));
const ViewSurvey = lazy(() => import('pages/Executor/View'));
const Ward = lazy(() => import('pages/Executor/Ward'));
const Hospital = lazy(() => import('pages/Executor/Hospitals'));
const WardsLists = lazy(() => import('pages/Executor/WardsList'));
const Patient = lazy(() => import('pages/Executor/PatientDashboard'));
const Dashboard = lazy(() => import('pages/Executor/Dashboard'));
const ChecklistPreview = lazy(() => import('pages/Admin/ChecklistPreview'));

export const routes = [
	{
		path: '/',
		name: 'Home',
		component: Hospital,
	},
	{
		path: '/kpi/:kpiId',
		name: 'Dasboard',
		component: Dashboard,
	},
	//{
	// 	path: '/user/formDesign/preview/:surveyId/',
	// 	name: 'Checklist Preview',
	// 	component: ChecklistPreview,
	// },
	{
		path: '/user/formDesign/preview/:checklistId/',
		name: 'Checklist Preview',
		component: ChecklistPreview,
	},
	{
		path: '/hospital/:hospitalId',
		name: 'Wards',
		component: WardsLists,
	},
	{
		path: '/survey/:surveyId',
		name: 'Survey',
		component: Survey,
	},
	{
		path: '/viewSurvey/:surveyId',
		name: 'View Survey',
		component: ViewSurvey,
	},
	{
		path: '/patient/:patientId',
		name: 'Patient',
		component: Patient,
	},

	{
		path: '/ward/:wardId/',
		name: 'Ward Details',
		component: Ward,
	},
];

export default routes;
